/**
 * @generated SignedSource<<58c9996493be7c4586aa55d5f1cf6961>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedEditorialModuleItem_item$data = {
  readonly cta: string | null;
  readonly description: string | null;
  readonly imageHeight: string | null;
  readonly imageUrl: string | null;
  readonly imageWidth: string | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedModuleItemTile_linkData">;
  };
  readonly title: string | null;
  readonly " $fragmentType": "HpSharedEditorialModuleItem_item";
};
export type HpSharedEditorialModuleItem_item$key = {
  readonly " $data"?: HpSharedEditorialModuleItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedEditorialModuleItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedEditorialModuleItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedModuleItemTile_linkData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialItem",
  "abstractKey": null
};

(node as any).hash = "b5907d0902391f2f4c5bace551ab637f";

export default node;
